import {
    ALL_TRIPS_TRIP_ID,
    DEFAULT_ON_TIME_LOWER_SECONDS,
    DEFAULT_ON_TIME_UPPER_SECONDS,
} from 'src/routes/trip-analyzer/data/trip-analyzer.constants';
import { types } from 'src/routes/trip-analyzer/data/trip-analyzer.types';

export const getDefaultTripAnalyzerQuery = () => ({
    serviceDate: null,
    routeKey: null,
    directionId: null,
    observedTripIds: [ALL_TRIPS_TRIP_ID],
    partnerKeys: [],
    compareEnabled: false,
    compareTrips: [],
    compareVisibleTripKeys: [],
    compareServiceDate: null,
    compareObservedTripId: null,
    timeWindowStart: null,
    timeWindowEnd: null,
    onTimeLowerSeconds: DEFAULT_ON_TIME_LOWER_SECONDS,
    onTimeUpperSeconds: DEFAULT_ON_TIME_UPPER_SECONDS,
});

const createCatalogSlice = () => ({
    items: [],
    loading: false,
    error: null,
});

export const getInitialTripAnalyzerState = () => ({
    query: getDefaultTripAnalyzerQuery(),
    catalog: {
        routes: createCatalogSlice(),
        directions: createCatalogSlice(),
        trips: createCatalogSlice(),
        partners: [],
    },
    serviceDates: {
        availableDates: [],
        minDate: null,
        maxDate: null,
        loading: false,
        error: null,
    },
    columns: {
        items: [],
        loading: false,
        error: null,
        cacheKey: null,
    },
    timeline: {
        data: null,
        loading: false,
        error: null,
        message: null,
    },
    comparePreview: {
        data: null,
        loading: false,
        error: null,
        message: null,
    },
    tripOrderByCorridor: {},
    tspPanel: {
        open: false,
        loading: false,
        error: null,
        marker: null,
        sessions: [],
        events: [],
    },
});

export const resetTripAnalyzer = () => ({
    type: types.RESET_TRIP_ANALYZER,
});

export const setTripAnalyzerQuery = (payload) => ({
    type: types.SET_QUERY,
    payload,
});

export const setTripAnalyzerCompareEnabled = (enabled) => ({
    type: types.SET_COMPARE_ENABLED,
    payload: enabled,
});

export const setTripAnalyzerTripOrder = (corridorKey, orderedTripIds) => ({
    type: types.SET_TRIP_ORDER,
    payload: { corridorKey, orderedTripIds },
});

export const openTripAnalyzerTspPanel = (marker) => ({
    type: types.OPEN_TSP_PANEL,
    payload: marker,
});

export const closeTripAnalyzerTspPanel = () => ({
    type: types.CLOSE_TSP_PANEL,
});

export const serviceDatesRequest = () => ({ type: types.SERVICE_DATES_REQUEST });
export const serviceDatesSuccess = (payload) => ({ type: types.SERVICE_DATES_SUCCESS, payload });
export const serviceDatesError = (error) => ({ type: types.SERVICE_DATES_ERROR, payload: error });

export const catalogRequest = (kind) => ({ type: types.CATALOG_REQUEST, payload: { kind } });
export const catalogSuccess = (kind, payload) => ({
    type: types.CATALOG_SUCCESS,
    payload: { kind, ...payload },
});
export const catalogError = (kind, error) => ({
    type: types.CATALOG_ERROR,
    payload: { kind, error },
});

export const columnsRequest = () => ({ type: types.COLUMNS_REQUEST });
export const columnsSuccess = (payload) => ({ type: types.COLUMNS_SUCCESS, payload });
export const columnsError = (error) => ({ type: types.COLUMNS_ERROR, payload: error });

export const timelineRequest = () => ({ type: types.TIMELINE_REQUEST });
export const timelineSuccess = (payload) => ({ type: types.TIMELINE_SUCCESS, payload });
export const timelineError = (error) => ({ type: types.TIMELINE_ERROR, payload: error });
export const timelineReset = () => ({ type: types.TIMELINE_RESET });

export const comparePreviewRequest = () => ({ type: types.COMPARE_PREVIEW_REQUEST });
export const comparePreviewSuccess = (payload) => ({ type: types.COMPARE_PREVIEW_SUCCESS, payload });
export const comparePreviewError = (error) => ({ type: types.COMPARE_PREVIEW_ERROR, payload: error });

export const tspEventsRequest = () => ({ type: types.TSP_EVENTS_REQUEST });
export const tspEventsSuccess = (payload) => ({ type: types.TSP_EVENTS_SUCCESS, payload });
export const tspEventsError = (error) => ({ type: types.TSP_EVENTS_ERROR, payload: error });
